import { inject, Injectable, signal } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { AuthService, OktaUserInfo } from '@brightside/core/auth';
import { ApiService, GenericResponseResult } from '@brighthub/api';

export interface EmployeeSearchPayload {
  payload: { users: OktaUserInfo[] };
}

@Injectable({
  providedIn: 'root'
})
export class EmployeeSearchService {

  private _api = inject(ApiService);
  private _activeEmployee = signal<OktaUserInfo | null>(null);
  public readonly activeEmployee = this._activeEmployee.asReadonly();

  queryEmployee(search: string): Observable<EmployeeSearchPayload & GenericResponseResult> {
    return this._api.get<EmployeeSearchPayload>('api-mobile',`/brightside-employee/user-search?query=${search}`);
  }

  selectEmployee(employeeInfo: OktaUserInfo) {
    this._activeEmployee.set(employeeInfo);
  }
}
